//NEW: UI_REVAMP
import { Box, Flex, Text, useDisclosure } from '@chakra-ui/react';
import { ReactComponent as BetList } from '../../assets/svg/list.svg';
import { useBottomSheetStore } from '../../hooks/useBottomSheetStore';
import { useBettingScreen } from '../../hooks/useStore';
import { MobileBetResultScreen } from '../../screen/MobileBetResultScreen';
import BottomSheet from '../../utils/BottomSheet';
import ImgComp from '../../utils/ImgComp';
import { BetResultImage } from '../bet-result/BetResultImage';
import ActionButton from '../button/ActionButton';
import GoldPatternButton from '../button/GoldPatternButton';
import BetNumberSelectors from '../keyboard/BetNumberSelectors';
import EnterPriceKeypad from '../keyboard/EnterPriceKeypad';
import BettingControls from './BettingControls';
import BettingList from './BettingList';
import SimpleBettingList from './SimpleBettingList';

const BettingMobileView = ({
	showBetList,
	activeBetTab,
	setActiveBetTab,
	activeSiteType,
	setActiveSiteType,
	getDraw,
	getGame,
	time,
	setTime,
	timeBtnId,
	setTimeBtnId,
	timeName,
	setTimeName,
	serverTime,
	activeBetType,
	setActiveBetType,
	handleLucky,
	handleEz2Add,
	setShowBetList,
	swer3Selection,
	ez2Selection,
	handleDigitClick,
	handleAddToList,
	handleBet2SwerAdd,
	handleBet2EzAdd,
	handleBet3Add,
	setIsLuckyPick,
	onOpenCheckout,
	betting,
	removeBetting,
	removeAllByDigit,
	gameId,
	isDisabled,
	isSelectionIncomplete,
	invalidBetIds,
	setInvalidBetIds,
}) => {
	const results = useBettingScreen((state) => state.results);
	const isBetStatus = !!results;
	const isBetListEmpty = betting.length === 0;
	//bottomSheet
	const activeSheet = useBottomSheetStore((s) => s.activeSheet);
	const isBottomSheetOpen = activeSheet !== null;
	const openBottomSheet = useBottomSheetStore((s) => s.openBottomSheet);

	//add to list
	const showAddToList =
		activeBetTab === 'bet1' ||
		((activeBetTab === 'bet2' || activeBetTab === 'bet3') && activeSiteType === 1);
	const showEnterPrice =
		activeBetTab === 'bet1' || activeBetTab === 'bet2' || activeBetTab === 'bet3';

	const {
		isOpen: isEnterPriceOpen,
		onOpen: onEnterPriceOpen,
		onClose: onEnterPriceCloseInternal,
		onToggle: onEnterPriceToggle,
	} = useDisclosure({ defaultIsOpen: true });

	const onEnterPriceClick = () => {
		openBottomSheet('betList');
		onEnterPriceOpen();
	};

	if (isBetStatus) {
		return (
			<>
				<MobileBetResultScreen downloadId='bet-result-ticket-mobile' />
				<BetResultImage results={results} id='bet-result-ticket-mobile' />
			</>
		);
	}

	return (
		<>
			<Flex
				flexDirection='column'
				w='full'
				h='full'
				display={{ base: 'flex', lg: 'none' }}
				bgGradient={
					isBottomSheetOpen
						? ''
						: 'linear-gradient(180.62deg, #F3F1FF 50%, #CEC9FF 99.47%), radial-gradient(46.23% 63.98% at 50.14% 100%, #C1B5FE 0%, rgba(255, 255, 255, 0) 100%)'
				}
			>
				<BettingControls
					activeBetTab={activeBetTab}
					setActiveBetTab={setActiveBetTab}
					activeSiteType={activeSiteType}
					setActiveSiteType={setActiveSiteType}
					getDraw={getDraw}
					getGame={getGame}
					time={time}
					setTime={setTime}
					timeBtnId={timeBtnId}
					setTimeBtnId={setTimeBtnId}
					timeName={timeName}
					setTimeName={setTimeName}
					serverTime={serverTime}
					activeBetType={activeBetType}
					setActiveBetType={setActiveBetType}
					handleLucky={handleLucky}
					handleEz2Add={handleEz2Add}
					showBetList={showBetList}
					setShowBetList={setShowBetList}
				/>
				<Flex
					w='full'
					flex='1'
					minH='0'
					gap={2}
					overflowY='hidden'
					pb={2}
					pointerEvents={isDisabled ? 'none' : 'auto'}
				>
					{showBetList && (
						<Box w='25%' minW='0' pt={1} pl={2}>
							<SimpleBettingList getGame={getGame} />
						</Box>
					)}
					<Box minW='0' flex='1' pr={2} pl={!showBetList ? 2 : 0} pt={1}>
						<BetNumberSelectors
							activeBetTab={activeBetTab}
							activeSiteType={activeSiteType}
							swer3Selection={swer3Selection}
							ez2Selection={ez2Selection}
							onDigitClick={handleDigitClick}
							onAddToListSwer={handleBet2SwerAdd}
							onAddToListEz={handleBet2EzAdd}
							onAddToListBet3={handleBet3Add}
							betting={betting}
							removeBetting={removeBetting}
							removeAllByDigit={removeAllByDigit}
							gameId={gameId}
							drawId={timeBtnId}
							activeBetType={activeBetType}
							onManualInteract={() => setIsLuckyPick(false)}
							isSelectionIncomplete={isSelectionIncomplete}
							isDisabled={isDisabled}
						/>
					</Box>
				</Flex>

				{(showAddToList || showEnterPrice) && (
					<Flex w='full' alignItems='center' justifyContent='center' gap={2} px={2} pb={2}>
						{showAddToList && (
							<Box flex={1}>
								<ActionButton
									onClick={handleAddToList}
									isDisabled={isDisabled || isSelectionIncomplete}
								>
									<BetList size={16} />
									<Text as='span'>Add to Bet List</Text>
								</ActionButton>
							</Box>
						)}

						{showEnterPrice && (
							<Box flex={1}>
								<GoldPatternButton onClick={onEnterPriceClick} isDisabled={isBetListEmpty}>
									<ImgComp svgName='coin' w={6} h={6} />
									<Text as='span'>Enter Bet Price</Text>
								</GoldPatternButton>
							</Box>
						)}
					</Flex>
				)}
			</Flex>
			<BottomSheet
				id='betList'
				title='Betting List'
				mainContent={
					<BettingList
						getGame={getGame}
						activeBetTab={activeBetTab}
						pb={isEnterPriceOpen ? 'calc(244px + 33px)' : 'calc(52px + 33px)'}
						invalidBetIds={invalidBetIds}
						setInvalidBetIds={setInvalidBetIds}
					/>
				}
				expandContent={
					<EnterPriceKeypad
						activeBetTab={activeBetTab}
						onClick={onOpenCheckout}
						isDisabled={isBetListEmpty}
					/>
				}
				isExpandOpen={isEnterPriceOpen}
				onToggleExpand={onEnterPriceToggle}
				onClose={onEnterPriceCloseInternal}
			/>
		</>
	);
};

export default BettingMobileView;
